<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12" class="mb-3">
          <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
          <b-button variant="danger" @click="openDeleteModal()" v-if="'news/' + $route.params.id" class="pull-left back-btn">Verwijderen</b-button>
        </b-col>
        <b-col cols="12">

          <b-form @submit.prevent="updateData">
          <b-card no-body>
            <template v-slot:header>
              <span class="pull-left mt-2 mb-2">{{item.title}}</span>
            </template>
            <b-tabs pills card>
              <b-tab title="Details" active>
            <b-col cols="12" class="mt-2">

              <b-form-group label="Titel">
                <b-form-input type="text" required v-model="item.title" :disabled="!editable"></b-form-input>
              </b-form-group>
              <b-form-group label="Datum">
                <b-form-input type="date" required v-model="item.date" :disabled="!editable"></b-form-input>
              </b-form-group>
              <b-form-group label="Zichtbaar in portaal">
                <b-form-checkbox required v-model="item.show_on_website" switch value=1 unchecked-value=0 :disabled="!editable"></b-form-checkbox>
              </b-form-group>
              <b-form-group label="Korte beschrijving">
                <b-form-input type="text" v-model="item.description" :disabled="!editable"></b-form-input>
              </b-form-group>

              <b-form-group label="Inhoud">

                <ckeditor
                  v-model="item.content"
                  :disabled="!editable"
                  :editor="editor"
                  :config="editorConfig"/>

              </b-form-group>
            </b-col>
              </b-tab>
              <b-tab title="Bestanden">

                <news-upload v-on:uploadedFiles="updateFiles" :options="item.project_mediatypes"/>
                <news-documents v-on:deletedFile="removeFile" :featured_image="item.featured_image" :images="item.news_images"
                                   :files="item.news_files"/>
              </b-tab>
            </b-tabs>

            <template v-slot:footer>
              <a class="btn btn-primary pull-left hoverable" @click="editable=true" v-if="!editable">Bewerken</a>
              <a class="btn btn-warning pull-left hoverable" @click="cancelEdit" v-if="editable">Annuleer</a>
              <b-button type="submit" variant="success" class="pull-right" v-if="editable">Opslaan</b-button>
            </template>
          </b-card>
          </b-form>
        </b-col>
      </b-row>
    </div>
    <b-modal id="delete-object" ref="delete-object" title="Verwijder object" v-if="deletable">
      <p class="my-4">
        Weet je zeker dat je het object <strong>"{{deletable.title}}"</strong> wilt verwijderen? Deze
        actie is onomkeerbaar.
      </p>
      <template v-slot:modal-footer>
        <b-button @click="hideDeleteModal">Nee</b-button>
        <b-button variant="danger" @click="deleteItem">Ja, verwijder</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {getData, deleteItem, updateData} from '@/api';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ClassicEditor from '@/assets/ckeditor5';
import NewsUpload from "@/views/news/parts/Upload";
import NewsDocuments from "@/views/news/parts/Documents";
import router from "@/router";

export default {
  name: 'news-single',
  components: { NewsUpload, NewsDocuments, ClassicEditor},
  props: ['id'],
  data() {
    return {
      saveButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      contacts: [],
      editable: false,
      item: [],
      errors: null,
      deletable: [],
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|',
            'bold', 'underline', 'italic', 'strikethrough', '|',
            'fontColor', 'fontBackgroundColor', '|',
            'indent', 'outdent', '|',
            'bulletedList', 'numberedList', '|',
            'link',
          ],
          height: '500px'
        },

        indentBlock: {
          offset: 1,
          unit: 'em'
        },

        fontColor: {
          colors: [
            {
              color: 'hsl(0, 0%, 0%)',
              label: 'Black'
            },
            {
              color: 'hsl(0, 0%, 52%)',
              label: 'Dim grey'
            },
            {
              color: 'hsl(19, 98%, 53%)',
              label: 'Orange'
            }
          ]
        }
      },
    }
  },
  methods: {
    async getItem() {
      const item = await getData('news/' + this.$route.params.id).then(response => response.data);
      this.item = item.data;
    },
    async updateData() {
      const request = await updateData('news/' + this.$route.params.id, {
        title: this.item.title,
        date: this.item.date,
        description: this.item.description,
        content: this.item.content,
        show_on_website: this.item.show_on_website
      }).then(response => response.data);
      this.item = request.data
      this.editable = false;
    },
    cancelEdit() {
      this.getItem();
      this.editable = false;
    },
    openDeleteModal() {
      this.deletable = this.item;
      this.$refs['delete-object'].show()
    },
    hideDeleteModal() {
      this.$refs['delete-object'].hide();
    },
    async deleteItem() {
      this.hideDeleteModal();
      await deleteItem('news/' + this.$route.params.id, false);
      await router.push({ name: 'news' });
    },
    updateFiles(data) {
      this.item.news_images = data.news_images;
      this.item.news_files = data.news_files;
    },
    removeFile(id) {
      this.item.news_images = this.item.news_images.filter(file => {
        return file.id != id;
      })
      this.item.news_files = this.item.news_files.filter(file => {
        return file.id != id;
      })

    },
  },
  beforeMount() {
    this.getItem();
  },
}

</script>
<style>
.ck-editor__editable {
  min-height: 300px;
}
</style>
